import { ValidationResult } from "./interface.validation";

export class PhoneValidator {
    static phoneFormat(item: any): ValidationResult {
        var PHONE_REGEXP: any;
        if (item.value) {
            var tt: any = item.value.replace(/[^0-9]/gi, '');

            if (tt.length === 10) {
                PHONE_REGEXP = /([0-9]{10})/;
            } else {
                PHONE_REGEXP = /([0-9]{11})/;
            }

            if (item.value && !PHONE_REGEXP.test(tt)) {
                return { "incorrectPhoneFormat": true };
            }
        }   
       
        return null;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/validators/phone.validation.ts
 **/